import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

import AttributeCard from "./AttributeCard";

import { formatLocationAddress } from "@/formatting/location";
import { type UserProfileAttributes } from "@/schemas/profile/UserProfileAttributes";
import { formatAge, formatRelationship, formatRole } from "@/utils/attributes";

type BasicAttributesProps = {
  attributes: UserProfileAttributes;
};

function BasicAttributes({
  attributes,
}: BasicAttributesProps): React.JSX.Element {
  const maxWidth = 25;
  const age = formatAge(attributes.birthday, maxWidth);
  const residence = formatLocationAddress(attributes.residence);
  const relationship = formatRelationship(attributes.relationship, maxWidth);
  const role = formatRole(attributes.role, maxWidth);

  return (
    <View style={styles.container}>
      <View style={styles.sectionContainer}>
        <Ionicons name="information-circle-outline" size={25} color="#01579b" />
        <Text style={styles.sectionTitle}>{"Personal Details"}</Text>
      </View>
      <View style={styles.grid}>
        <AttributeCard icon="🏠" title="Residence" value={residence} />
        <AttributeCard icon="🎂" title="Age" value={age} />
        <AttributeCard icon="👥" title="Relationship" value={relationship} />
        <AttributeCard icon="🔥" title="Role" value={role} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
  sectionContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 20,
    marginLeft: 5,
    fontWeight: "bold",
  },
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
});

export default BasicAttributes;
